export enum PriorityVisualizationType {
  STANDARD = 'standard',
  TEMPORARY = 'temporary',
  ABOUT_TO_END = 'aboutToEnd',
  DRAFT = 'draft',
  UNKNOWN = 'unknown',
}
